export default {
  pt: {
    'auth.primeiroAcesso.title': 'Crie a sua senha',
    'auth.primeiroAcesso.subtitle': 'Você entrou com uma senha temporária. Escolha a senha que vai usar daqui em diante.',
    'auth.primeiroAcesso.signedInAs': 'Conta',
    'auth.primeiroAcesso.newPassword': 'Nova senha',
    'auth.primeiroAcesso.confirmPassword': 'Confirmar nova senha',
    'auth.primeiroAcesso.mismatch': 'A confirmação não confere com a nova senha.',
    'auth.primeiroAcesso.save': 'Salvar e entrar',
    'auth.primeiroAcesso.saving': 'Salvando',
  },
  en: {
    'auth.primeiroAcesso.title': 'Create your password',
    'auth.primeiroAcesso.subtitle': 'You signed in with a temporary password. Choose the password you will use from now on.',
    'auth.primeiroAcesso.signedInAs': 'Account',
    'auth.primeiroAcesso.newPassword': 'New password',
    'auth.primeiroAcesso.confirmPassword': 'Confirm new password',
    'auth.primeiroAcesso.mismatch': 'The confirmation does not match the new password.',
    'auth.primeiroAcesso.save': 'Save and continue',
    'auth.primeiroAcesso.saving': 'Saving',
  },
  es: {
    'auth.primeiroAcesso.title': 'Cree su contraseña',
    'auth.primeiroAcesso.subtitle': 'Ingresó con una contraseña temporal. Elija la contraseña que usará de ahora en adelante.',
    'auth.primeiroAcesso.signedInAs': 'Cuenta',
    'auth.primeiroAcesso.newPassword': 'Nueva contraseña',
    'auth.primeiroAcesso.confirmPassword': 'Confirmar nueva contraseña',
    'auth.primeiroAcesso.mismatch': 'La confirmación no coincide con la nueva contraseña.',
    'auth.primeiroAcesso.save': 'Guardar y entrar',
    'auth.primeiroAcesso.saving': 'Guardando',
  },
}
